(() => {
  const money = (cents) => {
    const value = (Number(cents) || 0) / 100;
    return '$' + value.toFixed(2);
  };

  const init = (root) => {
    if (!root || root.dataset.pcv2Ready === 'true') return;
    root.dataset.pcv2Ready = 'true';

    let variants = [];
    try {
      variants = JSON.parse(
        root.querySelector('[data-pcv2-variants]')?.textContent || '[]'
      );
    } catch (e) {
      variants = [];
    }

    const currency = root.dataset.currency || 'AUD';

    const idInput = root.querySelector('[data-pcv2-variant-id]');
    const stickyId = root.querySelector('[data-pcv2-sticky-variant]');
    const stickySelect = root.querySelector('[data-pcv2-sticky-select]');
    const price = root.querySelector('[data-pcv2-price]');
    const stickyPrice = root.querySelector('[data-pcv2-sticky-price]');
    const installment = root.querySelector('[data-pcv2-installment]');
    const atc = root.querySelector('[data-pcv2-atc]');

    const showMedia = (id) => {
      root.querySelectorAll('[data-pcv2-media]').forEach((el) => {
        const active = String(el.dataset.pcv2Media) === String(id);
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });

      root.querySelectorAll('[data-pcv2-thumb]').forEach((el) => {
        el.classList.toggle(
          'is-active',
          String(el.dataset.pcv2Thumb) === String(id)
        );
      });

      root.querySelectorAll('[data-pcv2-dot]').forEach((el) => {
        el.classList.toggle(
          'is-active',
          String(el.dataset.pcv2Dot) === String(id)
        );
      });
    };

    root.querySelectorAll('[data-pcv2-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => showMedia(btn.dataset.pcv2Thumb));
    });

    root.querySelectorAll('[data-pcv2-dot]').forEach((btn) => {
      btn.addEventListener('click', () => showMedia(btn.dataset.pcv2Dot));
    });

    const mainMedia = root.querySelector('.pcv2__main-media');
    if (mainMedia) {
      let touchStartX = 0;
      let touchStartY = 0;

      const mediaIds = () =>
        [...root.querySelectorAll('[data-pcv2-media]')].map((el) => el.dataset.pcv2Media);

      const activeMediaId = () =>
        root.querySelector('[data-pcv2-media].is-active')?.dataset.pcv2Media;

      mainMedia.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      mainMedia.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;

        const dx = touch.clientX - touchStartX;
        const dy = touch.clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;

        const ids = mediaIds();
        const current = ids.indexOf(activeMediaId());
        if (current < 0) return;

        const next = dx < 0
          ? Math.min(current + 1, ids.length - 1)
          : Math.max(current - 1, 0);

        if (next !== current) showMedia(ids[next]);
      }, { passive: true });
    }

    const selectedOptions = () =>
      [...root.querySelectorAll('[data-pcv2-option]:checked')]
        .sort(
          (a, b) =>
            Number(a.dataset.optionPosition) -
            Number(b.dataset.optionPosition)
        )
        .map((input) => input.value);

    const syncVariant = () => {
      const options = selectedOptions();
      const variant = options.length
        ? variants.find((candidate) =>
            options.every(
              (value, index) => candidate.options[index] === value
            )
          )
        : variants[0];

      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (stickyId) stickyId.value = variant.id;
      if (stickySelect) stickySelect.value = variant.id;

      if (price) price.textContent = money(variant.price, currency);
      if (stickyPrice) stickyPrice.textContent = money(variant.price, currency);
      if (installment) {
        installment.textContent = money(
          Math.round(variant.price / 4),
          currency
        );
      }

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? 'ADD TO CART' : 'OUT OF STOCK';
      }

      if (variant.featured_media?.id) {
        showMedia(variant.featured_media.id);
      }

      root.querySelectorAll('[data-pcv2-option]:checked').forEach((input) => {
        const label = root.querySelector(
          `[data-pcv2-option-label="${input.dataset.optionPosition}"]`
        );
        if (label) label.textContent = input.value;
      });
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-pcv2-option]')) {
        syncVariant();
      }

      if (event.target.matches('[data-pcv2-sticky-select]')) {
        const variant = variants.find(
          (candidate) =>
            String(candidate.id) === String(event.target.value)
        );

        if (!variant) return;

        if (stickyId) stickyId.value = variant.id;
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = money(variant.price, currency);
        if (stickyPrice) stickyPrice.textContent = money(variant.price, currency);
        if (installment) {
          installment.textContent = money(
            Math.round(variant.price / 4),
            currency
          );
        }

        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? 'ADD TO CART' : 'OUT OF STOCK';
        }

        if (variant.featured_media?.id) {
          showMedia(variant.featured_media.id);
        }
      }
    });

    const wireStepper = (minusSelector, plusSelector, inputSelector) => {
      const input = root.querySelector(inputSelector);

      root.querySelector(minusSelector)?.addEventListener('click', () => {
        if (!input) return;
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });

      root.querySelector(plusSelector)?.addEventListener('click', () => {
        if (!input) return;
        input.value = Number(input.value || 1) + 1;
      });
    };

    wireStepper(
      '[data-pcv2-minus]',
      '[data-pcv2-plus]',
      '[data-pcv2-qty]'
    );

    wireStepper(
      '[data-pcv2-sticky-minus]',
      '[data-pcv2-sticky-plus]',
      '[data-pcv2-sticky-qty]'
    );

    const mobileAccordions = [...root.querySelectorAll('.pcv2__accordion-mobile details')];
    mobileAccordions.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        mobileAccordions.forEach((other) => {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      });
    });

    root.querySelectorAll('[data-pcv2-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-pcv2-tab]').forEach((tab) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
        });

        root.querySelectorAll('[data-pcv2-panel]').forEach((panel) => {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        const panel = root.querySelector(
          `[data-pcv2-panel="${btn.dataset.pcv2Tab}"]`
        );

        if (panel) {
          panel.hidden = false;
          panel.classList.add('is-active');
        }
      });
    });

    root.querySelectorAll('[data-pcv2-description-subtabs]').forEach((subtabs) => {
      const whyTab = subtabs.querySelector('[data-pcv2-description-why]');
      const whyPanel = subtabs.querySelector('[data-pcv2-description-why-panel]');
      if (!whyTab || !whyPanel) return;

      const closeWhy = () => {
        whyTab.classList.remove('is-active');
        whyTab.setAttribute('aria-selected', 'false');
        whyTab.setAttribute('aria-expanded', 'false');
        whyPanel.hidden = true;
      };

      whyTab.addEventListener('click', () => {
        const willOpen = whyPanel.hidden;
        if (willOpen) {
          whyTab.classList.add('is-active');
          whyTab.setAttribute('aria-selected', 'true');
          whyTab.setAttribute('aria-expanded', 'true');
          whyPanel.hidden = false;
        } else {
          closeWhy();
        }
      });

      const mobileDetails = subtabs.closest('.pcv2__accordion-mobile details');
      if (mobileDetails) {
        mobileDetails.addEventListener('toggle', () => {
          if (!mobileDetails.open) closeWhy();
        });
      }
    });

    const sizeGuideModal = root.querySelector('[data-pcv2-size-guide-modal]');
    const sizeGuideOpen = root.querySelector('[data-pcv2-size-guide-open]');
    const sizeGuideDrawer = root.querySelector('.pcv2__size-guide-drawer');
    const sizeGuideCloseButtons = root.querySelectorAll('[data-pcv2-size-guide-close]');
    let sizeGuideLastFocus = null;

    const closeSizeGuide = () => {
      if (!sizeGuideModal || sizeGuideModal.hidden) return;
      sizeGuideModal.hidden = true;
      document.body.classList.remove('pcv2-size-guide-open');
      if (sizeGuideLastFocus && typeof sizeGuideLastFocus.focus === 'function') {
        sizeGuideLastFocus.focus();
      }
    };

    const openSizeGuide = () => {
      if (!sizeGuideModal) return;
      sizeGuideLastFocus = document.activeElement;
      sizeGuideModal.hidden = false;
      document.body.classList.add('pcv2-size-guide-open');
      window.requestAnimationFrame(() => sizeGuideDrawer?.focus());
    };

    sizeGuideOpen?.addEventListener('click', openSizeGuide);
    sizeGuideCloseButtons.forEach((btn) => btn.addEventListener('click', closeSizeGuide));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sizeGuideModal && !sizeGuideModal.hidden) {
        closeSizeGuide();
      }
    });

    /*
      PDP Launch V2 sticky ATC rule:
      - hidden while the main purchase controls are visible
      - appears only after the main purchase controls have completely
        scrolled above the viewport
      - hides again when the customer scrolls back to the main controls
    */
    const sticky = root.querySelector('[data-pcv2-sticky]');
    const primaryPurchase = root.querySelector(
      '[data-pcv2-primary-purchase]'
    );

    if (sticky && primaryPurchase) {
      const applyVisibility = (entry) => {
        const visibleNow =
          entry.isIntersecting && entry.intersectionRatio > 0;
        const completelyAboveViewport =
          entry.boundingClientRect.bottom <= 0;

        sticky.classList.toggle(
          'is-visible',
          !visibleNow && completelyAboveViewport
        );
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(applyVisibility);
          },
          {
            root: null,
            threshold: [0, 0.01, 0.5, 1]
          }
        );

        observer.observe(primaryPurchase);
      } else {
        const fallback = () => {
          const rect = primaryPurchase.getBoundingClientRect();
          const visibleNow =
            rect.bottom > 0 && rect.top < window.innerHeight;
          const completelyAboveViewport = rect.bottom <= 0;

          sticky.classList.toggle(
            'is-visible',
            !visibleNow && completelyAboveViewport
          );
        };

        window.addEventListener('scroll', fallback, { passive: true });
        window.addEventListener('resize', fallback);
        fallback();
      }
    }

    syncVariant();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pcv2]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();